import { IconCheck, IconCircleDashed } from "@tabler/icons-react";
import { Badge, Group, Heading, Text, ThemeIcon } from "@/components/ui";
import { ReabrirCfdiBoton } from "./ReabrirCfdiBoton";

/**
 * Header del card de un CFDI dentro de `ProrrateoSeccion` · muestra
 * número de CFDI + UUID truncado + estado del prorrateo. A la derecha
 * vive el badge de estado o el botón de reabrir según corresponda.
 */
export function CfdiSeccionHeader({
  solicitudId,
  numeroCfdi,
  uuid,
  rfcEmisor,
  subtotalCfdi,
  estadoProrrateo,
  isConfirmado,
  soloLectura,
  onCambio,
}: {
  solicitudId: string;
  numeroCfdi: number;
  uuid: string;
  rfcEmisor: string;
  subtotalCfdi: number;
  estadoProrrateo: string;
  isConfirmado: boolean;
  soloLectura: boolean;
  onCambio: () => void;
}) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap">
      <Group gap="sm" align="flex-start" wrap="nowrap">
        <ThemeIcon size="lg" variant="light" color={isConfirmado ? "exito" : "slate"}>
          {isConfirmado ? <IconCheck size={20} stroke={1.8} /> : <IconCircleDashed size={20} stroke={1.6} />}
        </ThemeIcon>
        <div>
          <Group gap={8} align="baseline">
            <Heading order={5}>CFDI {numeroCfdi}</Heading>
            <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{uuid.slice(0, 13)}…</code>
          </Group>
          <Text size="sm" c="dimmed" className="mt-0.5">
            RFC emisor <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{rfcEmisor}</code> · subtotal ${subtotalCfdi.toFixed(2)} · estado{" "}
            <Text span fw={500}>
              {estadoProrrateo}
            </Text>
          </Text>
        </div>
      </Group>
      {isConfirmado && !soloLectura ? (
        <ReabrirCfdiBoton solicitudId={solicitudId} numeroCfdi={numeroCfdi} onReabierto={onCambio} />
      ) : isConfirmado ? (
        <Badge variant="light" color="exito">
          Confirmado
        </Badge>
      ) : (
        <Badge variant="light" color="slate">
          Pendiente
        </Badge>
      )}
    </Group>
  );
}
